import apiClient from "./api";
const ESTUDIOSSUB_API_BASE_URL = "/estudiosSub";

class EstudiosSubService {
  getEstudiosSub() {
    return apiClient.get(ESTUDIOSSUB_API_BASE_URL);
  }

  async getEstudioSubPorId(estudioId) {
    try {
      const response = await apiClient.get(`${ESTUDIOSSUB_API_BASE_URL}/${estudioId}`,);
      return response.data.estudios[0];
    } catch (error) {
      console.error(error);
    }
  }
}


export default new EstudiosSubService();
